/* eslint-disable css-modules/no-undef-class, css-modules/no-unused-class */
import { FC } from 'react';
import { Icon } from 'common-components';
import { iconTextDisplayProps } from './iconTextDisplayTypes';
import styles from './iconTextDisplay.module.scss';

const IconTextDisplay: FC<iconTextDisplayProps> = (props: iconTextDisplayProps) => {
    const { items, textClassName, valueClassName, hrColor, hrHeight } = props;

    return (
        <div
            className={styles['details-separator-wrapper']}
            style={{ '--hrColor': hrColor, '--hrHeight': hrHeight } as any}
        >
            {items.map((item, i) => (
                <>
                    <div className={styles.item}>
                        <div className={styles.texts}>
                            <Icon className={valueClassName} name={item.iconName} />
                            <div className={textClassName}>{item.text}</div>
                        </div>
                    </div>
                    {items.length - 1 !== i && <div className={styles.line} />}
                </>
            ))}
        </div>
    );
};

export default IconTextDisplay;
